// @charset "utf-8";
import Vue from 'vue'
import Router from 'vue-router'
// import home from '@/components/home'
import backtest from '@/components/backtest'
import strategybacktest from '@/components/strategybacktest'
import strategysquare from '@/components/strategysquare'
import eventevaluation from '@/components/eventevaluation'
import mystrategy from '@/components/mystrategy'
import strategydetail from '@/components/strategysquare/strategydetail'

Vue.use(Router)
const router = new Router({
    routes: [
        // 首页
        // {
        //     path: '/',
        //     name: 'home',
        //     component: home
        // },
        {
            path: '/backtest',
            name: 'backtest',
            component: backtest,
            meta: {
                keepAlive: true
            }
        },
        {
            path: '/strategybacktest',
            name: 'strategybacktest',
            component: strategybacktest,
            meta: {
                keepAlive: true
            }
        },
        {
            path: '/strategysquare',
            name: 'strategysquare',
            component: strategysquare,
            meta: {
                keepAlive: true
            }
        },
        {
            path: '/strategysquare/:id',
            name: 'strategydetail',
            component: strategydetail
        },
        {
            path: '/eventevaluation',
            name: 'eventevaluation',
            component: eventevaluation,
            meta: {
                keepAlive: true
            }
        },
        {
            path: '/mystrategy',
            name: 'mystrategy',
            component: mystrategy,
            meta: {
                keepAlive: true
            }
        }
    ]
})

router.beforeEach((to, from, next) => {
    if (to.path === '/') {
        window.location = '/'
        next(false)
    }
    if (to.path.indexOf('/pickresult') >= 0) {
        next(false)
        Vue.prototype.$Bus.$emit('pickresult', to.path.substring(12))
    } else {
        next()
    }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js